import { createFileRoute } from "@tanstack/react-router";
import { Mic, FileText, ListChecks } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import aiImg from "@/assets/ai-abstract.jpg";
import netImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/vi/platform/meetings")({
  head: () => ({
    meta: [
      { title: "Cuộc họp thông minh — banana.cards" },
      { name: "description", content: "Ghi âm, tóm tắt và biến cuộc họp thành action items — tự động." },
      { property: "og:title", content: "Cuộc họp thông minh — banana.cards" },
      { property: "og:description", content: "Ghi âm, tóm tắt và biến cuộc họp thành action items — tự động." },
      { property: "og:image", content: aiImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/meetings", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="Cuộc họp thông minh"
      title="Cuộc họp tự"
      italic="tóm tắt mình."
      description="Banana tham gia cuộc gọi của bạn, ghi âm, tóm tắt và trích xuất action items — gắn tất cả vào liên hệ và deal đúng."
      heroImage={aiImg}
      metrics={[{ v: "92%", l: "độ chính xác transcript" }, { v: "auto", l: "action items" }, { v: "50+", l: "ngôn ngữ" }]}
      bullets={[
        { icon: Mic, title: "Ghi âm & transcript", desc: "Zoom, Meet, Teams — Banana ghi âm và transcript tự động." },
        { icon: FileText, title: "Tóm tắt AI", desc: "Nhận tóm tắt ngắn gọn với điểm chính, quyết định và bước tiếp." },
        { icon: ListChecks, title: "Action items", desc: "Task được tự tạo và gán cho đúng người trong CRM." }
      ]}
      deepDives={[
        { eyebrow: "Bot ghi âm", title: "Banana tham gia,", italic: "bạn không cần ghi chú.", description: "Bot tự động tham gia cuộc gọi Zoom/Meet/Teams trong lịch, ghi âm và transcript trong thời gian thực.", image: aiImg, reverse: false, points: ["Tham gia tự động từ lịch", "Hỗ trợ Zoom, Meet, Teams", "Transcript với speaker labels", "Lưu trữ an toàn"] },
        { eyebrow: "Sau cuộc họp", title: "Tóm tắt, action,", italic: "follow-up.", description: "Sau cuộc gọi, nhận tóm tắt qua email với action items và bản nháp follow-up — sẵn sàng để gửi.", image: netImg, reverse: true, points: ["Email tóm tắt tự động", "Action items gán vào CRM", "Nháp follow-up cá nhân hóa", "Hỗ trợ Vietnamese & 50+ ngôn ngữ"] }
      ]}
      howItWorks={[
        { title: "Kết nối lịch", desc: "Banana thấy cuộc họp sắp tới." },
        { title: "Bot tham gia", desc: "Tự động vào cuộc gọi." },
        { title: "Nhận tóm tắt", desc: "Email sau cuộc gọi." },
        { title: "Action vào CRM", desc: "Task gán cho đúng người." }
      ]}
      capabilities={["Bot Zoom/Meet/Teams", "Transcript với speaker labels", "Tóm tắt AI sau cuộc gọi", "Trích xuất action items", "Nháp follow-up tự động", "Tìm kiếm transcript", "Hỗ trợ 50+ ngôn ngữ", "Lưu trữ mã hóa"]}
      faq={[
        { q: "Banana hoạt động với platform họp nào?", a: "Zoom, Google Meet, Microsoft Teams. Bot Banana tham gia tự động dựa trên lịch của bạn." },
        { q: "Có cần thông báo cho người tham gia không?", a: "Có — Banana tự động thông báo với người tham gia rằng cuộc họp đang được ghi âm. Bạn có thể tùy chỉnh thông điệp." },
        { q: "Transcript có chính xác bằng tiếng Việt không?", a: "Có — độ chính xác ~92% cho tiếng Việt chuẩn, với speaker labels và timestamp." },
        { q: "Dữ liệu cuộc họp có an toàn không?", a: "Có — mã hóa khi lưu, không bao giờ dùng để huấn luyện model toàn cục, có thể xóa bất cứ lúc nào." }
      ]}
      outro={{ title: "Ngừng ghi chú.", italic: "Bắt đầu hiện diện.", description: "Banana xử lý phần ghi nhớ. Bạn xử lý phần kết nối." }}
    />
  );
}